// extracted by mini-css-extract-plugin
module.exports = {"component":"Info_component__2J9Sv","content":"Info_content__1CJbl"};